<template>
  <div style="overflow-x: hidden;">
    <notifications position="bottom left" />

    <LoginDialog />
    <LoadingDialog />
    <MessageDialog />
      
        <!-- <div :class="{'col-sm-3': sidebar, 'col-md-2': sidebar, 'col-1': !sidebar}">
          <SideNavbar />
        </div>
        <div :class="{'col-sm-9': sidebar, 'col-md-10': sidebar, 'col-11': !sidebar}">
          <TopNavbar />
          <div class="w-100 h-100 p-3">
            <slot />
            <Footer />
          </div>
        </div> -->

        <div style="margin-top: 60px;">
            <slot />
        </div>

        <!-- <SideNavbar />
        <div class="d-inline-flex align-items-start" :class="{'': sidebar, '': !sidebar}">
          <TopNavbar />
          <div class="w-100 h-100 p-3">
            <slot />
            <Footer />
          </div>
        </div> -->
  </div>
</template>

<script>
/**
 * Use this template for Authenticated views.
 * NOTE: See BaseTemplate.vue for further explanation.
 */

import BaseDialogMixin from "@/components/mixins/BaseDialogMixin.vue";
import BaseAlertMixin from "@/components/mixins/BaseAlertMixin.vue";

import LoginDialog from "@/components/dialogs/LoginDialog.vue";
import MessageDialog from "@/components/dialogs/MessageDialog.vue";
import LoadingDialog from "@/components/dialogs/LoadingDialog.vue";

import resize from 'vue-resize-directive';

import { mapState, mapActions } from "vuex";

// import store from "@/store/store";

export default {
  mixins: [BaseDialogMixin, BaseAlertMixin],
  directives: {
    resize
  },
  components: {
    LoginDialog,
    MessageDialog,
    LoadingDialog
  },
  // beforeRouteEnter(to, from, next) {
  //   store.dispatch("setBaseComponent", "DashboardBaseTemplate");
  //   next();
  // },
  // beforeRouteUpdate(to, from, next) {
  //   this.setBaseComponent("DashboardBaseTemplate");
  //   next();
  // },
  created: function() {
    // this.setBaseComponent("DashboardBaseTemplate");
  },
  computed: {
    ...mapState(["sidebar"])
  },
  methods: {
    ...mapActions([
      "toggleSidebar"
    ]),
    // ...mapActions(["setBaseComponent"])
    onResize: function() {
      if(this.sidebar && window.outerWidth < 768) {
        this.toggleSidebar();
      } else if(!this.sidebar && window.outerWidth >= 768) {
        this.toggleSidebar();
      }
    }
  }
};
</script>